import { clientPublic } from '../../helper/axios'
import { removeCookie, setCookie } from '../../helper/cookie'
import { UserActionTypes } from './user.types'

import Swal from 'sweetalert2'
import './logmodal.scss'

export const loginUser = ({ username, password, remember }) => {
  return async (dispatch) => {
    const headers = {
      'Content-Type': 'application/json',
    }

    await clientPublic
      .post(
        'account/login',
        { username, password },
        {
          headers,
        },
      )
      .then((response) => {
        const { data, status } = response
        if (status === 200) {
          handleLoginSuccess(dispatch, data, remember)
        } else {
          dispatch({
            type: UserActionTypes.LOGIN_FAIL,
            payload: '',
          })

          return Swal.fire({
            title: 'LOGIN FAILD',
            icon: 'question',
            showConfirmButton: true,
            timer: 1500,
            showClass: {
              popup: 'animate__animated animate__fadeInDown',
            },
            hideClass: {
              popup: 'animate__animated animate__fadeOutUp',
            },
          })
        }
      })
      .catch((error) => {
        const { response } = error
        handleLoginFailed(response)
      })
  }
}

const handleEventLoginSuccess = (id, lastLogin) => {
  // Push event to the dataLayer
  window.dataLayer = window.dataLayer || []
  dataLayer.push({
    event: 'Event_Count_Period_UserID_Login_Success',
    User_Id: id,
    Login_Success: true,
    Timestamp: lastLogin,
  })
}

export const LoginLINK_Axons = async ({ email }) => {
  try {
    return await clientPublic
      .post(`linkaxons?email=${email}`, {
        'Content-Type': 'application/json',
      })
      .then((response) => {
        const { status, data } = response
        if (status === 200) {
          const { url_login } = data
          window.location.href = url_login
        }
        return response
      })
      .catch((error) => {
        const { response } = error
        handleLoginFailed(response)
        return response
      })
  } catch (error) {
    return 'errorcatch'
  }
}

export const verifyLandingLoginFormAxons = (key) => {
  return async (dispatch) => {
    await clientPublic
      .post('ad/login', { username: String(key) }, { 'Content-Type': 'application/json' })
      .then((response) => {
        const { data, status } = response
        const remember = false // result type: boolean
        if (status === 200) {
          handleLoginSuccess(dispatch, data, remember)
        }
      })
      .catch((error) => {
        const { response } = error
        handleLoginFailed(response)
      })
  }
}

export const logoutUser = () => {
  return async (dispatch) => {
    dispatch({
      type: UserActionTypes.LOGOUT_SUCCESS,
      payload: '',
    })
    removeCookie('access_token_admin')
  }
}

export const refreshToken = (token) => {
  return async (dispatch) => {
    dispatch({
      type: UserActionTypes.REFRESH_TOKEN,
      payload: token,
    })
  }
}

const handleLoginSuccess = (dispatch, data, remember) => {
  const {
    company_id,
    role_id,
    id,
    firstname,
    lastname,
    email,
    pic_display,
    role,
    token_jwt,
    lastlogin,
  } = data
  if (remember === true) {
    setCookie('access_token_admin', data.token_jwt)
  } else {
    setCookie('access_token_admin', data.token_jwt, { expires: null })
  }
  setCookie('ProfessSK_comID', company_id)
  setCookie('roleUser', role_id)
  setCookie('userID', id)
  handleEventLoginSuccess(id, lastlogin)
  const infoUser = {
    firstname: firstname,
    lastname: lastname,
    email: email,
    pic_display: pic_display,
  }

  setCookie('infoUser', infoUser)
  setCookie('roleNameDefault', role)
  //################## IMPORTANT FOR HOOKS AUTO CHANG TO LOGGED IN #############
  //################## ******************************************* #############
  //################## ******************************************* #############
  dispatch({
    type: UserActionTypes.LOGIN_SUCCESS,
    payload: token_jwt,
  })
  //################## ******************************************* #############
  //################## ******************************************* #############
  //################## IMPORTANT FOR HOOKS AUTO CHANG TO LOGGED IN #############
}

export const handleLoginFailed = (response) => {
  const { data } = response
  const codeError = data?.errorCode
  return Swal.fire({
    title: 'Login Failed',
    text:
      codeError == 2022
        ? `Login failed
    Your account has been temporarily locked 
    Please try again in 30 minutes or contact your administrator.`
        : 'The email or password you entered is incorrect or not found in the system. Please try again or contact the administrator.',
    iconColor: '#FF6258',
    icon: 'error',
    width: 634,
    height: 341,
    showCloseButton: true,
    showLoaderOnConfirm: true,
    showConfirmButton: true,
    timer: 0,
    showClass: {
      popup: 'animate__animated animate__fadeInDown',
    },
    hideClass: {
      popup: 'animate__animated animate__fadeOutUp',
    },
  })
}
